const AuthContextTexts = {
  /* Messages */
  'contexts.authContext.messages.updateAvatarSubmitConfirm.title':
    'Do you really want to update your avatar?',
  'contexts.authContext.messages.updateAvatarSubmitConfirm.description':
    'This action cannot be undone',
  'contexts.authContext.messages.updateAvatarSubmitConfirm.confirmButton':
    'Update avatar',
  'contexts.authContext.messages.updateAvatarSubmitSuccess.title':
    'Your avatar has been updated!',
};

export default {
  ...AuthContextTexts,
};
